import dynamic from 'next/dynamic';

import { PageTitle as CollabPageTitle } from '@collab/molecules';

import { useVersioning } from 'molecules/Versions/VersioningProvider';

const Versions = dynamic(() => import('molecules/Versions/Versions'));

export type PageTitleMdxProps = {
  title: string;
  category?: string;
  sticky?: boolean;
};

const PageTitle: React.FC<PageTitleMdxProps> = ({
  title,
  sticky,
  category,
}) => {
  const { versions } = useVersioning();
  const categoryArray = category?.split(',');

  return (
    <CollabPageTitle
      title={title}
      sticky={sticky}
      category={categoryArray}
      versionsComponent={
        versions?.length ? <Versions versions={versions} /> : undefined
      }
    />
  );
};

export default PageTitle;
